import { Card, ListaControlesSkeleton, RegionCargando, Skeleton, Stack } from "@/components/ui";

/**
 * Pestaña del gestor de módulos en carga (fallback de Suspense) · misma forma que
 * «Por rol»: selector + acciones, encabezado del rol y la tarjeta con los grupos
 * de módulos (checkbox + descripción + código) en 2 columnas.
 */
export function ModulosPanelSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando módulos…">
      <Stack gap="md">
        <div className="flex flex-wrap items-end justify-between gap-3" aria-hidden="true">
          <div className="flex w-80 max-w-full flex-col gap-1.5">
            <Skeleton height={12} width={40} />
            <Skeleton height={36} />
          </div>
          <Skeleton height={36} width={140} />
        </div>
        <div className="flex flex-col gap-1.5" aria-hidden="true">
          <Skeleton height={14} width={220} />
          <Skeleton height={10} width="70%" />
        </div>
        <Card padding="lg">
          <div className="grid gap-6 sm:grid-cols-2">
            {[4, 3, 4, 3].map((n, i) => (
              <div key={i} className="flex flex-col gap-2">
                <Skeleton height={10} width={90} aria-hidden="true" />
                <ListaControlesSkeleton filas={n} control="checkbox" conDescripcion anunciar={false} />
              </div>
            ))}
          </div>
        </Card>
      </Stack>
    </RegionCargando>
  );
}

/**
 * Módulos de un usuario en carga («Por usuario») · nombre + roles, ayuda y la
 * tarjeta de grupos con filas descripción/código y el control Heredar·Otorgar·Bloquear.
 */
export function ModulosDeUsuarioSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando módulos del usuario…" className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5" aria-hidden="true">
        <div className="flex items-center gap-2">
          <Skeleton height={14} width={180} />
          <Skeleton height={20} width={90} className="rounded-full" />
        </div>
        <Skeleton height={10} width="75%" />
      </div>
      <Card padding="lg">
        <div className="flex flex-col gap-6" aria-hidden="true">
          {[4, 3].map((n, g) => (
            <div key={g} className="flex flex-col gap-2">
              <Skeleton height={10} width={90} />
              {Array.from({ length: n }, (_, i) => (
                <div key={i} className="flex items-center justify-between gap-3 px-2 py-1.5">
                  <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                    <Skeleton height={12} width={i % 2 === 0 ? "50%" : "38%"} />
                    <div className="flex gap-1.5">
                      <Skeleton height={10} width={120} />
                      <Skeleton height={14} width={56} className="rounded-full" />
                    </div>
                  </div>
                  <Skeleton height={26} width={190} className="shrink-0" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </Card>
    </RegionCargando>
  );
}
